import { Component } from '@angular/core';
import { formControl, formGroup, Validators } from '@al00x/forms';
import { CacButtonComponent, CacFieldComponent, ButtonClickEvent } from '@controladad/ng-base';

interface DeliveryTimeSettings {
  englishText: string;
  arabicText: string;
  referenceTime: string;
  timeZone?: string;
}

@Component({
  selector: 'lib-delivery-time-settings',
  standalone: true,
  imports: [CacButtonComponent, CacFieldComponent],
  template: `
    <section class="max-w-3xl p-6 space-y-4">
      <h1 class="text-xl font-semibold">Delivery Time Settings</h1>
      @if (error) { <p role="alert">{{ error }}</p> }
      <cac-field [control]="form.controls.englishText" label="Delivery Time Text (English)" />
      <cac-field [control]="form.controls.arabicText" label="Delivery Time Text (Arabic)" />
      <cac-field [control]="form.controls.referenceTime" label="Delivery Time Reference Time (UTC)" controlType="input" inputType="time" />
      <cac-button icon="device-floppy" [disabled]="loading || form.invalid" (onClick)="save($event)">Save</cac-button>
    </section>
  `,
})
export class DeliveryTimeSettingsComponent {
  loading = true;
  error = '';
  form = formGroup({
    englishText: formControl<string>('', [Validators.required, Validators.maxLength(1024)]),
    arabicText: formControl<string>('', [Validators.required, Validators.maxLength(1024)]),
    referenceTime: formControl<string>('00:00', [Validators.required, Validators.pattern(/^([01]\d|2[0-3]):[0-5]\d$/)]),
  });

  constructor() { this.load(); }

  load() {
    http$.get<DeliveryTimeSettings>('/AdminPanel/GetDeliveryTimeSettings').subscribe({
      next: settings => { this.form.patchValue(settings); this.loading = false; },
      error: () => { this.error = 'Unable to load delivery settings'; this.loading = false; },
    });
  }

  save(event: ButtonClickEvent) {
    if (this.form.invalid || this.loading) return;
    this.error = '';
    http$.put('/AdminPanel/SetDeliveryTimeSettings', this.form.value).pipe(event.pipe()).subscribe({
      next: () => snackbar$.show('Delivery settings saved'),
      error: () => this.error = 'Unable to save delivery settings',
    });
  }
}
